import React from 'react';
import useOrgName from '../../hooks/useOrgName';
import { TemplateContinue } from '../../components/TemplateContinue';
import useAmountSelectionButtonText from '../../LinkApiRouter/hooks/useAmountSelectionButtonText';
import useSkipDepositConfirmation from '../../LinkApiRouter/hooks/useSkipDepositConfirmation';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import useSelectedAccountText from '../../LinkApiRouter/hooks/useSelectedAccountText';
function RemainderSwitchConfirmation(props) {
    var getLocalizedString = useGetLocalizedString();
    var orgName = useOrgName();
    useSkipDepositConfirmation(props.onContinue);
    var buttonText = useAmountSelectionButtonText();
    var selectedAccountText = useSelectedAccountText();
    return (React.createElement(TemplateContinue, { title: getLocalizedString('CONFIRM_DEPOSIT_SETTINGS'), subtitle: getLocalizedString('YOUR_PAYCHECK_WILL_BE_DEPOSITED', [
            selectedAccountText || orgName,
        ]), onContinue: function () {
            props.onContinue();
        }, buttonLabel: buttonText, buttonEventId: "AmountSelection-continue" }));
}
export default RemainderSwitchConfirmation;
